import { Segmented } from 'antd';

import ArrowBack from '../../../../assets/images/ArrowBack';
import { CustomShipmentText } from '../../../../components';
import {
  FilterLogic,
  normalizeFilterLogic,
  supportsFilterLogic,
} from '../filterLogic';

type SubFilterHeaderProps = {
  filterBy: string;
  filterTitle: string;
  filterLogic: FilterLogic;
  hideBackArrow?: boolean;
  onFilterLogicChange?: (logic: FilterLogic) => void;
  setSecondFilterDisplay: (display: boolean) => void;
  setIsFilterOpen: (open: boolean) => void;
};

const SubFilterHeader: React.FC<SubFilterHeaderProps> = ({
  filterBy,
  filterTitle,
  filterLogic,
  hideBackArrow,
  onFilterLogicChange,
  setSecondFilterDisplay,
  setIsFilterOpen,
}) => (
  <div
    className='subfilter-header-content'
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 8,
      width: '100%',
      minWidth: 220,
    }}
  >
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        minWidth: 0,
      }}
    >
      {!hideBackArrow && (
        <ArrowBack
          fill='var(--text-secondary)'
          style={{
            width: 16,
            height: 16,
            cursor: 'pointer',
            marginLeft: filterTitle === 'Alerts' ? -5 : -2,
            flexShrink: 0,
          }}
          onClick={() => {
            setSecondFilterDisplay(false);
            setIsFilterOpen(true);
          }}
        />
      )}

      <CustomShipmentText
        text={filterTitle}
        fontWeight='600'
        color='var(--text-secondary)'
      />
    </div>

    {supportsFilterLogic(filterBy) && (
      <Segmented
        size='small'
        options={[
          { label: 'Or', value: 'OR' },
          { label: 'And', value: 'AND' },
        ]}
        value={normalizeFilterLogic(filterLogic)}
        onChange={(value) =>
          onFilterLogicChange?.(normalizeFilterLogic(value) as FilterLogic)
        }
        className='subfilter-logic-toggle'
      />
    )}
  </div>
);

export default SubFilterHeader;
